import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideOptimus } from '@openng/optimus-ui/config';
import { MessageService, ConfirmationService } from '@openng/optimus-ui/api';
import { definePreset } from '@openng/optimus-ui-themes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { JsonDateInterceptor } from './interceptors/json-date.interceptor';
import { naNormalizerInterceptor } from './interceptors/na-normalizer.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { provideNgIconsConfig } from '@ng-icons/core';
import { provideEchartsCore } from 'ngx-echarts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideOptimus({
      theme: {
        preset: definePreset((await import('@openng/optimus-ui-themes/lara')).default, {
          components: {
            menubar: {
              item: { focusColor: '{primary.color}' },
            },
            chip: {
              colorScheme: {
                light: {
                  root: { background: '{primary.50}', color: '{primary.700}' },
                },
              },
            },
          },
          semantic: {
            formField: {
              paddingX: '0.625rem',
              paddingY: '0.375rem',
              sm: { paddingX: '0.5rem', paddingY: '0.25rem', fontSize: '0.875rem' },
            },
            primary: {
              50: '{blue.50}',
              100: '{blue.100}',
              200: '{blue.200}',
              300: '{blue.300}',
              400: '{blue.400}',
              500: '{blue.500}',
              600: '{blue.600}',
              700: '{blue.700}',
              800: '{blue.800}',
              900: '{blue.900}',
              950: '{blue.950}',
            },
          },
        }),
        options: {
          darkModeSelector: false,
          cssLayer: { name: 'optimus', order: 'theme, base, optimus' },
        },
      },
    }),
    provideBrowserGlobalErrorListeners(),
    provideNgIconsConfig({ size: '1em' }),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        errorInterceptor,
        naNormalizerInterceptor,
        JsonDateInterceptor,
      ])
    ),
    provideRouter(routes),
    provideEchartsCore({ echarts: () => import('./charts/echarts-setup') }),
    MessageService,
    ConfirmationService,
  ],
};
